import { render, staticRenderFns } from "./HbEmptyState.vue?vue&type=template&id=0b6e10f1&scoped=true&"
import script from "./HbEmptyState.vue?vue&type=script&lang=js&"
export * from "./HbEmptyState.vue?vue&type=script&lang=js&"
import style0 from "./HbEmptyState.vue?vue&type=style&index=0&id=0b6e10f1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6e10f1",
  null
  
)

export default component.exports